var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteAlertIcon = function SvgDeleteAlertIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#5F677E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F677E",
    strokeLinejoin: "round",
    d: "M8.757 15.246 7.605 9.269h9.456l-1.15 5.977c-.097.5-.165.847-.239 1.116-.072.261-.142.41-.224.524a1.5 1.5 0 0 1-.57.47c-.126.06-.287.1-.557.122-.277.022-.63.022-1.14.022h-1.695c-.51 0-.863 0-1.14-.022-.27-.022-.431-.062-.558-.122a1.5 1.5 0 0 1-.569-.47c-.083-.113-.152-.263-.225-.524a16 16 0 0 1-.237-1.116Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F677E",
    d: "M14.5 8.667v.525h-4.333v-.525a2.167 2.167 0 1 1 4.333 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F677E",
    strokeLinecap: "round",
    d: "M13.667 12H11M7 9.096h10.667"
  })));
};
export default SvgDeleteAlertIcon;